import style from "./createCatalog.module.scss"
import {useEffect, useRef, useState} from "react";
import {API_URL} from "../../../http";


const CreateCatalog = ({active, setActive, create, data, update}) => {

    const [catalog, setCatalog] = useState({name: data?.name || "", description: data?.description || "", url: data?.url || ""});
    const [imageFile, setImageFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const fileInputRef = useRef(null);

    useEffect(() => {
        setCatalog({name: data?.name || "", description: data?.description || "", url: data?.url || ""})
    }, [active.visible]);

    const close = () =>{
        setActive({visible: false, categoryId: -1})
        setCatalog({name: "", description: "", url: "", })
        setImageFile(null)
        setPreview(null)
    }

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith('image/')) {
            setImageFile(file); // сохраняем сам файл
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            setPreview(null);
            alert('Пожалуйста, выберите изображение.');
        }
    };

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleRemoveImage = () => {
        setPreview(null);
        fileInputRef.current.value = null; // сбрасываем input
    };

    const handleSubmit = (e) => {


        e.preventDefault();
        let formData = new FormData();
        if(active.categoryId === -1){
            if (catalog.name === "" || catalog.description === "" || catalog.url === "") {
                return null
            }
            formData.append("name", catalog.name);
            formData.append("description", catalog.description);
            formData.append("url", catalog.url);
            formData.append("file", imageFile);
        }else{
            if (catalog.name === "") {
                return null
            }
            formData.append("name", catalog.name);
        }

        if (Object.keys(data).length !== 0){
            formData.append("id", data?.id);
            update(formData)
        }else {
            formData.append("categoryId", active.categoryId);
            create(formData)
        }

        close()
    }
    
    return (
        <div className={active.visible ? [style.block, style.blockActive].join(" ") : style.block}>
            <div className={style.title}>Настройки каталогов</div>
            <button className={style.back} onClick={close}>Назад</button>
            <div className={style.label}>{active.categoryId === -1 ? "Название каталога" : "Название подкаталога"}</div>
            <input className={style.input} type="text" placeholder="Сеты" value={catalog?.name} onChange={(e)=> setCatalog({...catalog, name: e.target.value})}/><br/>
            {active.categoryId === -1 &&
                <>
                    <div className={style.label}>SEO Название</div>
                    <input className={style.input} type="text" placeholder="Доставка роллов Майкоп" value={catalog?.description} onChange={(e)=> setCatalog({...catalog, description: e.target.value})}/>
                    <div className={style.label}>url</div>
                    <input className={style.input} type="text" placeholder="/rolls" value={catalog?.url} onInput={(e)=> setCatalog({...catalog, url: e.target.value})}/>
                    <div className={style.photo}>
                        <div>
                            <div className={style.label}>Фото каталога</div>
                            <div className={style.description}>Фотография не должна превышать 5 мегабайт. Оптимальный размер не менее 1080 х 1080. При загрузке изображение автоматически настраивается на дополнительный размер</div>
                            <div className={style.photoUpload}>

                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={fileInputRef}
                                    onChange={handleImageChange}
                                    className={style.hiddenInput}
                                    disabled={!!preview}
                                />

                                <button onClick={handleButtonClick} className={style.uploadButton} disabled={!!preview}>
                                    {data?.image !== undefined ? "Изменить фото" : <><span className={style.plus}>＋</span> Загрузить фото</>}
                                </button>
                            </div>
                        </div>
                        <div>
                            {preview
                                ? <>
                                    <div className={style.previewContainer}>
                                        <div className={style.cropImage}>
                                            <img src={preview} alt="Предпросмотр" className={style.previewImage} />
                                        </div>
                                        <button className={style.deleteImage} onClick={handleRemoveImage}>
                                            <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16.8037 6.19531L6.19711 16.8019" stroke="#CE1919" strokeWidth="2" strokeLinecap="round" />
                                                <path d="M16.8037 16.8027L6.19711 6.19613" stroke="#CE1919" strokeWidth="2" strokeLinecap="round" />
                                            </svg>
                                        </button>
                                    </div>
                                </>
                                : data?.image !== undefined &&
                                <>
                                    <div className={style.previewContainer}>
                                        <div className={style.cropImage}>
                                            <img src={`${API_URL}/${data?.image}`} alt="Предпросмотр" className={style.previewImage} />
                                        </div>
                                    </div>
                                </>
                            }

                        </div>
                    </div>
                </>
            }
            <button className={style.btnSave} onClick={handleSubmit}>Сохранить каталог</button>

        </div>
    );
};

export default CreateCatalog;